import { render, staticRenderFns } from "./PurchaseCategoryQuickAdd.vue?vue&type=template&id=56005e8e&"
import script from "./PurchaseCategoryQuickAdd.vue?vue&type=script&lang=js&"
export * from "./PurchaseCategoryQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports